export const CHANGE_USER_LOCATION= 'app/LanguageToggle/CHANGE_USER_LOCATION'; /* eslint-disable-line */
export const REMOVE_USER_LOCATION= 'app/LanguageToggle/REMOVE_USER_LOCATION'; /* eslint-disable-line */
export const SYNC_LOCATIONS = 'SYNC_LOCATIONS' /* eslint-disable-line */
export const LOCATION_TRACKING = 'LOCATION_TRACKING'; /* eslint-disable-line */